<template>
  <div
      class="feedback"
      :class="{'feedback__fixed' : fixed, 'feedback__open' : opened }"
      @click="closeFixed"
  >
    <div id="request" class="popup">
      <div class="request__letter">
        <div class="request__items">

          <div class="request__name" :class="{error : errors && errors.name}">
            <input
                type="text"
                class="field field_elegant"
                placeholder="Ваше имя"
                v-model="feedback.name"
            />
            <div class="request__error" v-if="errors && errors.name">
              {{ errors.name }}
            </div>
          </div>

          <div class="request__phone" :class="{error : errors && errors.phone}">
            <input
                type="text"
                class="field field_elegant"
                placeholder="Телефон"
                v-mask="'+7 (###) ###-##-##'"
                v-model="feedback.phone"
            />
            <div class="request__error" v-if="errors && errors.phone">
              {{ errors.phone }}
            </div>
          </div>

          <div class="request__mail" :class="{error : errors && errors.email}">
            <input
                type="text"
                class="field field_elegant"
                placeholder="E-mail"
                name="email"
                v-model="feedback.email"
            />
            <div class="request__error" v-if="errors && errors.email">
              {{ errors.email }}
            </div>
          </div>

          <div v-if='partner' class="request__city" :class="{error : errors && errors.city}">
            <input
                type="text"
                class="field field_elegant"
                placeholder="Ваш город"
                name="city"
                v-model="feedback.city"
            />
            <div class="request__error" v-if="errors && errors.city">
              {{ errors.city }}
            </div>
          </div>

          <div class="rating__comment" :class="{error : errors && errors.message}">
            <textarea
                cols="40"
                rows="5"
                placeholder="Комментарий"
                class="textspace"
                v-model="feedback.message"
            >
            </textarea>
            <div class="request__error" v-if="errors && errors.message">
              {{ errors.message }}
            </div>
          </div>

        </div>

        <div class="request__confirm">
          <div
              class="request__text"
              v-if="request_message"
              :class="{
                'request__error': status === 'error',
                'request__success': status === 'success',
              }"
              role="status"
              aria-live="polite"
          >
            {{ request_message }}
          </div>

          <label class="custom-ui custom-ui_colored">
            <div class="request__check">
              <input
                  id="check"
                  class="custom-ui__input"
                  type="checkbox"
                  name="check"
                  checked
                  @change="disabled = !disabled"
              />
              <label class="custom-ui__presence" for="check"> </label>
              <a href="/consent" class="custom-ui__text">
                Я даю согласие на обработку персональных данных
              </a>
            </div>
          </label>
        </div>
        <button class="request__final primitive" type="submit" @click="recaptcha" :disabled="disabled || spin">
          <span class="loader" v-if="spin">
            <span class="lds-ripple"><div></div><div></div></span>
          </span>
          <span>{{ spin ? 'Отправка…' : 'Отправить заявку' }}</span>
        </button>
      </div>
      <a
          v-if="fixed"
          href="#"
          @click="close"
          class="closeme popup__closeme"
      >
      </a>
    </div>
  </div>
</template>

<script>
import { postFeedback } from '../api/adminBrands';

export default {
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    opened: {
      type: Boolean,
      default: false,
    },
    partner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      feedback: {
        name: null,
        phone: null,
        email: null,
        message: null,
        type: null,
      },
      spin: false,
      errors: null,
      status: null,
      request_message: null,
      disabled: false,
      closeTimer: null,
    }
  },
  created() {
    this.initForm();
  },
  beforeDestroy() {
    this.clearCloseTimer()
  },
  methods: {
    close(event) {
      event.preventDefault();
      this.clearCloseTimer()
      this.$emit('close', { enabled: false })
    },
    closeFixed(event) {
      if (this.fixed)
        if (!event.target.closest('.popup'))
          this.$emit('close', { enabled: false })
    },
    clearCloseTimer() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    },
    initForm: function() {
      this.feedback.type = 1

      if (this.partner) {
        this.feedback.city = null
        this.feedback.type = 2
      }
    },
    async postFeedbackForm(data) {
      this.errors = null
      this.status = null
      this.request_message = null
      this.clearCloseTimer()
      try {
        const result = await postFeedback(data, data.token)
        this.spin = false
        if (result && result.success) {
          for (let key in this.feedback)
            this.feedback[key] = null
          this.initForm()
          this.status = 'success'
          this.request_message = this.feedback.type == 1 ? result.message || 'Сообщение успешно отправлено' : 'Заявка на партнерство успешно отправлена!'
          if (this.fixed) {
            this.closeTimer = setTimeout(() => {
              this.$emit('close', { enabled: false })
              this.closeTimer = null
            }, 2500)
          }
        } else {
          this.status = 'error'
          this.errors = (result && result.inputs) || null
          this.request_message = (result && result.message)
            || 'Не удалось отправить сообщение. Проверьте поля и попробуйте снова.'
        }
      } catch (e) {
        this.spin = false
        this.status = 'error'
        this.errors = null
        this.request_message = 'Не удалось отправить сообщение. Попробуйте позже.'
      }
    },
    async recaptcha() {
      if (this.spin || this.disabled) return
      this.spin = true
      this.status = null
      this.request_message = null
      try {
        await this.$recaptchaLoaded()
        this.feedback.token = await this.$recaptcha('login')
        await this.postFeedbackForm(this.feedback)
      } catch (e) {
        this.spin = false
        this.status = 'error'
        this.request_message = 'Не удалось пройти проверку. Обновите страницу и попробуйте снова.'
      }
    },
  }
}
</script>

<style>


</style>